import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProducts, fetchPackageProductsDetail } from '../../redux/managePackageSlice';

const Product = ({
  language,
  selectedProductType,
  onUpdate,
  initialSelectedProducts = [],
  initialSelectedDomainType = "",
  packageId
}) => {
  const dispatch = useDispatch();
  const {
    products: apiResponse,
    loading,
    error,
    domainTypeProductMap,
    packageProductsDetailLoading
  } = useSelector(state => state.managePackage);

  const [availableProducts, setAvailableProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedDomainType, setSelectedDomainType] = useState("");

  useEffect(() => {
    if (packageId && language) {
      dispatch(fetchPackageProductsDetail({
        packageId,
        region: 'SG'
      }));
    }
  }, [packageId, language, dispatch]);

  useEffect(() => {
    if (language) {
      dispatch(fetchProducts({ language }));
    }
  }, [language, dispatch]);

  useEffect(() => {
    if (apiResponse && apiResponse.resdata && Array.isArray(apiResponse.resdata)) {
      const products = apiResponse.resdata.map(item => {
        const basicInfo = item.contentJson?.basicInfo || {};
        return {
          id: item.uuid,
          uuid: item.uuid,
          name: basicInfo.name,
          description: basicInfo.price,
          domainType: item.domainType || [],
        };
      });
      setAvailableProducts(products);
    }
  }, [apiResponse]);

  useEffect(() => {
    if (domainTypeProductMap && selectedProductType) {
      const domainType = selectedProductType.value;
      const productsForDomain = domainTypeProductMap[domainType] || [];

      setSelectedDomainType(domainType);
      setSelectedProducts(productsForDomain);

      if (onUpdate) {
        onUpdate(productsForDomain, domainType);
      }
    }
  }, [domainTypeProductMap, selectedProductType, onUpdate]);

  const handleCheckboxChange = (productId) => {
    const newSelectedProducts = selectedProducts.includes(productId)
      ? selectedProducts.filter(id => id !== productId)
      : [...selectedProducts, productId];

    setSelectedProducts(newSelectedProducts);

    if (onUpdate) {
      onUpdate(newSelectedProducts, selectedDomainType);
    }
  };

  if (loading || packageProductsDetailLoading) {
    return (
      <div className="tab-package-container">
        <div className="loading">Loading products...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="tab-package-container">
        <div className="error">Error: {error}</div>
      </div>
    );
  }

  return (
    <div className="tab-package-container">
      <div>
        {availableProducts.map(product => (
          <div key={product.id} className="product-item">
            <label className="product-checkbox-label">
              <input
                type="checkbox"
                checked={selectedProducts.includes(product.uuid)}
                onChange={() => handleCheckboxChange(product.uuid)}
                className="product-checkbox-input"
              />
              <span className={`product-checkmark ${selectedProducts.includes(product.uuid) ? 'checked' : ''}`}>
                {selectedProducts.includes(product.uuid) && <span className="checkmark-icon">✓</span>}
              </span>
              <span className="product-text">
                <span className="product-label">{product.name}:</span>
                {product.description && (
                  <span className="product-name">{product.description}</span>
                )}
              </span>
            </label>
          </div>
        ))}

        {availableProducts.length === 0 && !loading && (
          <div className="no-products">No products available</div>
        )}
      </div>
    </div>
  );
};

export default Product;